// NOTICE: KAPTION-INTEGRATION
// ai-connectors.CONSENT.1: keep a pending AI connection across sign-in.
// The consent URL carries the AI tool's signed request (`oreq`). When a
// signed-out person opens it, the dashboard sends them to /app/login and the
// URL was lost, so they had to start over from the AI tool. We park the path
// in sessionStorage (same tab, cleared on close) and send them back to it on
// their first signed-in navigation, whichever way they signed in.
const KEY = 'kaption_pending_ai_connect';
const MAX_AGE_MS = 15 * 60 * 1000;
const CONSENT_ROUTE = 'kaption_mcp_authorize';

const storage = () => {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
};

export const rememberPendingConnect = to => {
  if (to?.name !== CONSENT_ROUTE || !to.query?.oreq) return;
  try {
    storage()?.setItem(
      KEY,
      JSON.stringify({ path: to.fullPath, at: Date.now() })
    );
  } catch (e) {
    // private mode or blocked storage: the person restarts from the AI tool
  }
};

// Returns the parked consent path once (and forgets it), or null.
export const takePendingConnect = (now = Date.now()) => {
  const store = storage();
  if (!store) return null;
  try {
    const raw = store.getItem(KEY);
    if (!raw) return null;
    store.removeItem(KEY);
    const { path, at } = JSON.parse(raw);
    if (typeof path !== 'string' || !path.startsWith('/app/mcp-authorize'))
      return null;
    if (!at || now - at > MAX_AGE_MS) return null;
    return path;
  } catch (e) {
    return null;
  }
};

export const PENDING_CONNECT_CONSENT_ROUTE = CONSENT_ROUTE;
